import { useEffect, useRef } from "react";

// Renders a Lodgify-generated embed snippet. React does not execute scripts added via
// innerHTML, so script nodes are recreated deliberately.
export default function LodgifyWidget({ html }) {
  const host = useRef(null);

  useEffect(() => {
    const root = host.current;
    if (!root) return;
    root.replaceChildren();

    const template = document.createElement("template");
    template.innerHTML = html;
    const nodes = [...template.content.childNodes];

    for (const node of nodes) {
      if (node.nodeType !== Node.ELEMENT_NODE || node.tagName !== "SCRIPT") {
        root.appendChild(node.cloneNode(true));
        continue;
      }
      const script = document.createElement("script");
      for (const attr of node.attributes) script.setAttribute(attr.name, attr.value);
      if (node.src) script.src = node.src;
      else script.textContent = node.textContent;
      root.appendChild(script);
    }

    return () => root.replaceChildren();
  }, [html]);

  return <div ref={host} className="w-full" aria-label="Lodgify booking widget" data-testid="lodgify-booking-widget" />;
}
